// extracted by mini-css-extract-plugin
module.exports = {"image-anim":"ImageAnim_image-anim__b5vYE","image-anim__base":"ImageAnim_image-anim__base__u6Apt","image-anim__dupe":"ImageAnim_image-anim__dupe__fGHhG"};